import React from "react";
import logo from "../../images/SS.png";
import "./viewbill.css";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { useLocation } from "react-router-dom";
import { ToWords } from "to-words";
import { Button } from "@mui/material";
const ViewBill = () => {
  const location = useLocation();
  console.log(location, "newLocation");
  const Customer = location?.state?.customer;
  const Invoice = location?.state?.Invoice;
  const toWords = new ToWords();
  const product_data = location?.state?.product_data;
  const MyDoc = ({ data }) => (
    <Document>
      <Page size={""}>
        <View style={{ fontFamily: "Courier" }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: 10,
              marginLeft: 10,
            }}
          >
            <View
              style={{
                width: "20%",
              }}
            >
              <Image
                src={logo}
                style={{ height: 50, width: 120, marginTop: 10 }}
              />
            </View>
            {/* Top Right Date */}
            {/* <Text
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                fontSize: 10,
                fontFamily: "Courier",
              }}
            >
              Date: {data?.product_data?.data?.[0]?.date}
            </Text> */}

            {/* Company Address */}
            <View
              style={{
                width: "80%",
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  marginTop: 5,
                  fontSize: 20,
                  textAlign: "center",
                  marginRight: "25%",
                }}
              >
                S S Fashion
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  marginTop: 5,
                  textAlign: "center",
                  marginRight: "25%",
                }}
              >
                A/GF/46, Sardar Patel Mall, Nikol Gam Road,
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  textAlign: "center",
                  marginRight: "25%",
                }}
              >
                Thakkarbapanagar, Bapunagar,
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  textAlign: "center",
                  marginRight: "25%",
                }}
              >
                Ahmedabad - 382350
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  textAlign: "center",
                  marginRight: "25%",
                }}
              >
                Phone No. : 7600107385
              </Text>
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "bold",
                  textAlign: "center",
                  marginRight: "25%",
                }}
              >
                GSTIN : 24AISPP4775D1ZV
              </Text>
            </View>
          </View>
          <Text
            style={{ fontWeight: "bold", fontSize: 30, textAlign: "center" }}
          >
            Invoice
          </Text>
          <View
            style={{
              border: "1px solid black",
              // padding: "5px",
              marginLeft: "5px",
              marginRight: "5px",
              // height:"650px"
            }}
          >
            <View style={{ display: "flex", padding: "10px", fontSize: 10 }}>
              <View>
                <Text>Invoice No. : {Invoice}</Text>
                <Text>Invoice Date : {product_data?.date}</Text>
                <Text>State : Gujarat</Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 10,
                // marginLeft: 10,
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
              }}
            >
              <View
                style={{
                  // textAlign: "center",
                  // marginTop: "5px",
                  paddingTop: 5,
                  fontSize: 10,
                  width: "50%",
                  borderRight: "1px solid black",
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    borderBottom: "1px solid black",
                  }}
                >
                  Details Of Recipient / Billed to
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13 }}>Name</Text> : {Customer?.name}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13 }}>Address</Text> :{" "}
                  {Customer?.address}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13 }}>Mobile No</Text>:{" "}
                  {Customer?.mobileNumber}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13 }}>City</Text> : {Customer?.city}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13 }}>State</Text> :{" "}
                  {Customer?.state} - {Customer?.pincode}
                </Text>
              </View>
              <View
                style={{
                  // textAlign: "center",
                  marginTop: "5px",
                  width: "50%",
                  // paddingRight:20,
                  // borderBottom: "1px solid black",
                  // borderTop: "1px solid black",
                  fontSize: 10,
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    borderBottom: "1px solid black",
                  }}
                >
                  Details Of Consignee ( Shipped to )
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13, paddingLeft: 10 }}>Name</Text> :{" "}
                  {Customer?.name}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13, paddingLeft: 10 }}>Address</Text>{" "}
                  : {Customer?.address}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13, paddingLeft: 10 }}>
                    Mobile No
                  </Text>
                  : {Customer?.mobileNumber}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13, paddingLeft: 10 }}>City</Text> :{" "}
                  {Customer?.city}
                </Text>
                <Text style={{ paddingLeft: 10 }}>
                  <Text style={{ fontSize: 13, paddingLeft: 10 }}>State</Text> :{" "}
                  {Customer?.state} - {Customer?.pincode}
                </Text>
              </View>
            </View>
            {/* <View
              style={{
                display: "flex",
                padding: "10px",
                marginTop: "5px",
                fontSize: 10,
                borderBottom: "1px solid black",
              }}
            >
              <View>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>Name</Text> :{" "}
                  {Customer?.name}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>Address</Text> :{" "}
                  {Customer?.address}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>Mobile No</Text>:{" "}
                  {Customer?.mobileNumber}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>City</Text> :{" "}
                  {Customer?.city}
                </Text>
                <Text>
                  <Text style={{ fontWeight: "bold" }}>State</Text> :{" "}
                  {Customer?.state} - {Customer?.pincode}
                </Text>
              </View>
            </View> */}
            <View style={styles.content}>
              <View style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "6%",
                    }}
                  >
                    Sr No
                  </Text>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "35%",
                    }}
                  >
                    Description Of Goods
                  </Text>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "13%",
                    }}
                  >
                    HSN Code
                  </Text>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    GST Rate
                  </Text>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    Qty
                  </Text>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "12%",
                    }}
                  >
                    Rate
                  </Text>
                  <Text
                    style={{
                      padding: 2,
                      fontSize: 12,
                      // borderRightWidth: 1,
                      borderColor: "black",
                      textAlign: "center",
                      width: "14%",
                    }}
                  >
                    Amount
                  </Text>
                </View>
                {/* Table Body */}
                {data.product_data?.data?.map((val, index) => (
                  <View style={styles.tableRow} key={index}>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "6%",
                      }}
                    >
                      {index + 1}
                    </Text>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "35%",
                      }}
                    >
                      {val?.product?.product_name}
                    </Text>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "13%",
                      }}
                    >
                      {val?.product?.HSN}
                    </Text>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "10%",
                      }}
                    >
                      {val?.product?.gst_rate} %
                    </Text>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "10%",
                      }}
                    >
                      {val?.quantity}
                    </Text>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "12%",
                      }}
                    >
                      {parseFloat(val?.selling_price).toFixed(2)}
                    </Text>
                    <Text
                      style={{
                        padding: 2,
                        fontSize: 12,
                        // borderRightWidth: 1,
                        borderColor: "black",
                        textAlign: "center",
                        width: "14%",
                      }}
                    >
                      {parseFloat(val?.final_price).toFixed(2)}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                // marginBottom: 10,
                // marginLeft: 10,
                // borderBottom: "1px solid black",
                // borderTop: "1px solid black",
              }}
            >
              <View style={{ width: "65%", borderRightWidth: 1, fontSize: 10 }}>
                <View
                  style={{
                    borderBottomWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      textDecoration: "underline black 1px",
                    }}
                  >
                    Total Invoice Amount In Words : -
                  </Text>
                  <Text style={{ paddingLeft: 25, marginBottom: 5 }}>
                    {toWords.convert(
                      parseFloat(product_data?.invoice_amount).toFixed(2)
                    ) +
                      " " +
                      "Only"}
                  </Text>
                  <p></p>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    // justifyContent: "space-between",
                    padding: 10,
                    // paddingTop:10,
                    // padding
                    borderBottomWidth: 1,
                  }}
                >
                  <View style={{ width: "30%" }}>
                    <Text>Bank Name :</Text>
                    <Text>A/C No :</Text>
                    <Text>IFSC Code :</Text>
                    <Text>Branch :</Text>
                    <Text>PAN No :</Text>
                  </View>
                  <View>
                    <Text>ICICI BANK LTD</Text>
                    <Text>093005500739</Text>
                    <Text>ICIC0000930</Text>
                    <Text>BAPUNAGAR</Text>
                    <Text>AISPP4775D</Text>
                  </View>
                </View>
                <View
                  style={{
                    borderBottomWidth: 1,
                    paddingLeft: 5,
                    paddingTop: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      textDecoration: "underline black 1px",
                    }}
                  >
                    Terms And Condition
                  </Text>
                  <Text style={{ paddingLeft: 25, marginBottom: 5 }}>
                    Jurisdiction Will be Ahmedabad Only
                  </Text>
                  
                 
                   
    
                </View>
                <View style={{padding: 10 , fontSize:13}}>  <Text> Email : kishankachiya9090@gmail.com</Text></View>
              </View>
              <View style={{ width: "35%" }}>
               <View style={{
                    flexDirection: "colume",
                    // padding: 10,
                    borderBottomWidth: 1,
                    width:"100%",
                    fontSize:10
                  }}>

                  <View style={{flexDirection:'row' , borderBottomWidth:1 }}>
                    <Text style={{width:"65%" ,paddingLeft :5 ,paddingTop :5 ,borderRightWidth:1 , fontSize:9}}>Total Amount Before Tax</Text>
                    <Text  style={{width:"35%" ,paddingLeft :5 ,paddingTop :5 ,paddingBottom :5 }}>{parseFloat(product_data?.amount_before_tax).toFixed(2)}</Text>

                  </View>
                  <View style={{flexDirection:'row' , borderBottomWidth:1 }}>
                    <Text style={{width:"65%" ,paddingLeft :5 ,paddingTop :5   ,borderRightWidth:1}}>{Customer?.state == "Gujarat" ? "CGST 9.00" :"CGST 0.00" }</Text>
                    <Text  style={{width:"35%", paddingLeft :5,paddingTop :5 ,paddingBottom :5  }}>{Customer?.state == "Gujarat" ? parseFloat(product_data?.total_cgst).toFixed(2) : "0.00"}</Text>

                  </View>
                  <View style={{flexDirection:'row' , borderBottomWidth:1}}>
                    <Text style={{width:"65%" ,paddingLeft :5 ,paddingTop :5 ,borderRightWidth:1}}>{Customer?.state == "Gujarat" ? "SGST 9.00" : "SGST 0.00" }</Text>
                    <Text  style={{width:"35%" ,paddingLeft :5 ,paddingTop :5 ,paddingBottom :5  }}>{Customer?.state == "Gujarat" ? parseFloat(product_data?.total_sgst).toFixed(2) : "0.00"}</Text>

                  </View>
                  <View style={{flexDirection:'row' , borderBottomWidth:1}}>
                    <Text style={{width:"65%" ,paddingLeft :5 ,paddingTop :5 ,borderRightWidth:1}}>{Customer?.state == "Gujarat" ? "IGST 0.00" : "IGST 18.00" }</Text>
                    <Text  style={{width:"35%" ,paddingLeft :5 ,paddingTop :5 ,paddingBottom :5  }}>{Customer?.state == "Gujarat" ? "0.00" : parseFloat(product_data?.total_igst).toFixed(2)}</Text>

                  </View>
                  <View style={{flexDirection:'row' }}>
                    <Text style={{width:"65%" ,paddingLeft :5 ,paddingTop :5 ,borderRightWidth:1 ,fontSize:9}}>Total Amount After Tax</Text>
                    <Text  style={{width:"35%" ,paddingLeft :5 ,paddingTop :5  }}>{parseFloat(product_data?.invoice_amount).toFixed(2)}</Text>

                  </View>
               </View>
               <View>

                  <Text style={{fontSize:10}}>  For, <Text style={{fontSize:13}}>S S Fashion</Text></Text>
                  <Text style={{fontSize:10 , textAlign:"center",paddingTop:50}}>  Authorised Signatory </Text>
               </View>

              </View>
            </View>
            {/* 
            <View style={{ textAlign: "right", padding: "10px" }}>
              <Text>
                Total Bill Amount :
                {parseFloat(data?.product_data?.invoice_amount).toFixed(2)}
              </Text>
            </View>
            <View style={{ textAlign: "right", padding: "10px", fontSize: 10 }}>
              <Text>For, Lal Guru Traders</Text>
             
            </View>
            <View style={{ paddingTop: "30px" ,textAlign: "right", padding: "10px",fontSize: 10 }}>
                <Text>Authorised Signatory</Text>
              </View> */}
          </View>
        </View>
      </Page>
    </Document>
  );

  const styles = StyleSheet.create({
    page: {
      padding: 20,
    },
    container: {
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    header: {
      marginBottom: 20,
      textAlign: "center",
    },
    title: {
      fontSize: 24,
      fontWeight: "bold",
    },
    content: {
      width: "100%",
    },
    table: {
      width: "100%",
      borderStyle: "solid",
      borderTopWidth: 1,
      borderColor: "black",
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "black",
    },
    tableHeader: {
      padding: 5,
      fontWeight: "bold",
      textAlign: "center",
      borderRightWidth: 1,
      borderColor: "black",
    },
    tableCell: {
      padding: 5,
      textAlign: "center",
      borderRightWidth: 1,
      borderColor: "black",
    },
  });
  return (
    <>
      <div style={{ textAlign: "right", marginBottom: "1rem" }}>
        <Button
          variant="contained"
          style={{
            background:
              "linear-gradient(225deg,  var(--gradientColor1) 0%, var(--gradientColor2) 91.25%)",
          }}
          sx={{
            mt: 1,
            textTransform: "capitalize",
            borderRadius: "8px",
            fontWeight: "500",
            fontSize: "13px",
            padding: "12px 20px",
            minWidth: "0",
            minHeight: "0",
            color: "var(--themeFontColor) !important",
          }}
        >
          <PDFDownloadLink
            document={<MyDoc data={{ Customer, Invoice, product_data }} />}
            fileName={`${Invoice}.pdf`}
          >
            {({ loading }) => (
              <span style={{ color: "white" }}>
                {" "}
                {loading ? "Loading..." : "Save"}
              </span>
            )}
          </PDFDownloadLink>
        </Button>
      </div>
      <div className="Main_Bill_Div">
        <div className="Main_Header_section">
          {/* <div className="IMG_Header_section">
            <img src={logo} alt="LAL GURU" />
          </div> */}
          <div className="Add_Header_section">
            <h1>S S Fashion</h1>
            <p>
              A/GF/46, Sardar Patel Mall, Nikol Gam Road, Thakkarbapanagar,
              Bapunagar ,
            </p>
            <p>Ahmedabad - 382350</p>
            <p>Phone No. : 7600107385</p>
            <h3>GSTIN : 24AISPP4775D1ZV</h3>
          </div>
        </div>
        <div className="Invioce_Name">
          <h3>TAX Invoice</h3>
        </div>
        <div className="Main_Bill_section">
          <div className="First_Bill_Section">
            <div className="First_Bill_Section_key">
              <p>Invoice No. </p>
              <p>Invoice Date </p>
              <p>State </p>
              <p>State Code</p>
            </div>
            <div>
              <p>: {Invoice}</p>
              <p>: {product_data?.date}</p>
              <p>: Gujarat</p>
              <p>: GU</p>
            </div>
          </div>
          <div className="Bill_Details_section">
            <div style={{ flex: "1", borderRight: "1px solid black" }}>
              <p className="Bill_Details_section_Heading">
                Details Of Recipient / Billed to
              </p>
              <div className="Bill_Details_section_Details">
                <div>
                  <h6>Name :</h6>
                  <p>{Customer?.name}</p>
                </div>
                <div>
                  <h6>Address :</h6>
                  <p>{Customer?.address}</p>
                </div>
                <div>
                  <h6>Mobile No :</h6>
                  <p>{Customer?.mobileNumber}</p>
                </div>
                <div>
                  <h6>City :</h6>
                  <p>{Customer?.city}</p>
                </div>
                <div>
                  <h6>State :</h6>
                  <p>
                    {Customer?.state} - {Customer?.pincode}
                  </p>
                </div>
              </div>
            </div>
            <div style={{ flex: "1" }}>
              <p className="Bill_Details_section_Heading">
                Details Of Consignee ( Shipped to )
              </p>
              <div className="Bill_Details_section_Details">
                <div>
                  <h6>Name :</h6>
                  <p>{Customer?.name}</p>
                </div>
                <div>
                  <h6>Address :</h6>
                  <p>{Customer?.address}</p>
                </div>
                <div>
                  <h6>Mobile No :</h6>
                  <p>{Customer?.mobileNumber}</p>
                </div>
                <div>
                  <h6>City :</h6>
                  <p>{Customer?.city}</p>
                </div>
                <div>
                  <h6>State :</h6>
                  <p>
                    {Customer?.state} - {Customer?.pincode}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="Bill_Product_section">
            <div className="Bill_Product_heading_section">
              <p className="Bill_Product_heading_1">Sr No</p>
              <p className="Bill_Product_heading_2">Description Of Goods</p>
              <p className="Bill_Product_heading_3">HSN Code</p>
              <p className="Bill_Product_heading_4">GST Rate</p>

              <p className="Bill_Product_heading_5">Qty</p>
              <p className="Bill_Product_heading_6">Rate</p>
              {/* {Customer?.state == "Gujarat" && <p className="Bill_Product_heading_6">SGST</p>}
              {Customer?.state == "Gujarat" &&<p className="Bill_Product_heading_7">CGST</p>}
              {Customer?.state != "Gujarat" && <p className="Bill_Product_heading_8">IGST</p>} */}

              {/* <p className="Bill_Product_heading_9">Final Price</p> */}
              <p className="Bill_Product_heading_7">Amount</p>
            </div>
            {product_data &&
              product_data?.data?.map((val, index) => (
                <div className="Bill_Product_Value_section">
                  <p className="Bill_Product_Value_1">{index + 1}</p>
                  <p className="Bill_Product_Value_2">
                    {val?.product?.product_name}
                  </p>
                  <p className="Bill_Product_Value_3">{val?.product?.HSN}</p>
                  <p className="Bill_Product_Value_4">{val?.product?.gst_rate} %</p>

                  <p className="Bill_Product_Value_5">{val?.quantity}</p>
                  <p className="Bill_Product_Value_6">
                    {parseFloat(val?.selling_price).toFixed(2)}
                  </p>
                  {/* {  Customer?.state == "Gujarat" && <p className="Bill_Product_Value_6">
                  {parseFloat(val?.product_sgst).toFixed(2)}
                </p>}
              { Customer?.state == "Gujarat" && <p className="Bill_Product_Value_7">
                  {parseFloat(val?.product_cgst).toFixed(2)}
                </p>}
              { Customer?.state != "Gujarat" && <p className="Bill_Product_Value_8">
                  {parseFloat(val?.product_igst).toFixed(2)}
                </p>} */}
                  {/* <p className="Bill_Product_Value_9">
                  {parseFloat(val?.final_price).toFixed(2)}
                </p> */}
                  <p className="Bill_Product_Value_7">
                    {parseFloat(val?.selling_price * val?.quantity).toFixed(2)}
                  </p>
                </div>
              ))}
          </div>
          <div className="after_product_list">
            <div className="bank_details_part">
              <div className="amount_in_word_div">
                <h5>Total Invoice Amount In Words : -</h5>
                <p>
                  {toWords.convert(
                    parseFloat(product_data?.invoice_amount).toFixed(2)
                  ) +
                    " " +
                    "Only"}
                </p>
              </div>
              <div className="bank_acc_dateils">
                <div className="bank_acc_key">
                  <p>Bank Name :</p>
                  <p>A/C No :</p>
                  <p>IFSC Code :</p>
                  <p>Branch :</p>
                  <p>PAN No :</p>
                </div>
                <div>
                  <p>ICICI BANK LTD</p>
                  <p>093005500739</p>
                  <p>ICIC0000930</p>
                  <p>BAPUNAGAR</p>
                  <p>AISPP4775D</p>
                </div>
              </div>
              <div className="terms_condition_div">
                <h5>Terms And Condition</h5>
                <p>Jurisdiction Will be Ahmedabad Only</p>
              </div>
              <div className="email_div">
                Email : kishankachiya9090@gmail.com
              </div>
            </div>
            <div className="Bill_Product_Total_Amount_Sign_div">
              <div className="Bill_Product_Total_Amount">
                <div
                  style={{
                    borderBottom: "1px solid black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      padding: "0.5rem 0rem 0.5rem 1rem",
                      width: "70%",
                      borderRight: "1px solid black",
                    }}
                  >
                    Total Amount Before Tax
                  </p>
                  <p style={{ paddingRight: "1rem" }}>
                    {parseFloat(product_data?.amount_before_tax).toFixed(2)}
                  </p>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      padding: "0.5rem 0rem 0.5rem 1rem",
                      width: "70%",
                      borderRight: "1px solid black",
                    }}
                  >
                    {" "}
                    {Customer?.state == "Gujarat" ? (
                      <p>CGST 9.00</p>
                    ) : (
                      <p>CGST 0.00</p>
                    )}
                  </p>
                  <p style={{ paddingRight: "1rem" }}>
                    {" "}
                    {Customer?.state == "Gujarat" ? (
                      <p>{parseFloat(product_data?.total_cgst).toFixed(2)}</p>
                    ) : (
                      <p>0.00</p>
                    )}
                  </p>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      padding: "0.5rem 0rem 0.5rem 1rem",
                      width: "70%",
                      borderRight: "1px solid black",
                    }}
                  >
                    {" "}
                    {Customer?.state == "Gujarat" ? (
                      <p>SGST 9.00</p>
                    ) : (
                      <p>SGST 0.00</p>
                    )}
                  </p>
                  <p style={{ paddingRight: "1rem" }}>
                    {" "}
                    {Customer?.state == "Gujarat" ? (
                      <p>{parseFloat(product_data?.total_sgst).toFixed(2)}</p>
                    ) : (
                      <p>0.00</p>
                    )}
                  </p>
                </div>
                <div
                  style={{
                    borderBottom: "1px solid black",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      padding: "0.5rem 0rem 0.5rem 1rem",
                      width: "70%",
                      borderRight: "1px solid black",
                    }}
                  >
                    {" "}
                    {Customer?.state == "Gujarat" ? (
                      <p>IGST 0.00</p>
                    ) : (
                      <p>IGST 18.00</p>
                    )}
                  </p>
                  <p style={{ paddingRight: "1rem" }}>
                    {" "}
                    {Customer?.state == "Gujarat" ? (
                      <p>0.00</p>
                    ) : (
                      <p>{parseFloat(product_data?.total_igst).toFixed(2)}</p>
                    )}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <p
                    style={{
                      padding: "0.5rem 0rem 0.5rem 1rem",
                      width: "70%",
                      borderRight: "1px solid black",
                    }}
                  >
                    Total Amount After Tax
                  </p>
                  <p style={{ paddingRight: "1rem" }}>
                    {parseFloat(product_data?.invoice_amount).toFixed(2)}
                  </p>
                </div>
              </div>
              <div className="Bill_Signatory">
                <p>
                  For, <b> S S Fashion</b>
                </p>
                <div>Authorised Signatory</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewBill;
